// Shared kebab-case slug utility. Mirrors the backend `slugify()` shape so
// previews and saved invitations agree on the canonical form. Used by both
// InvitationEditorPage (newly-created invitation slugs) and TemplateDetailPage
// (preview slug shown under the URL bar of the laptop frame).
//
// Behaviour:
//   - lowercase
//   - replace any run of non [a-z0-9] characters with a single "-"
//   - collapse repeated dashes (belt-and-suspenders for callers that already
//     mapped each special char to a single dash, e.g. "anvar---ma-suma")
//   - trim leading/trailing dashes
//   - clamp to 60 chars (matches backend slug length cap)
export const kebab = (s: string): string =>
  s
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60)
    .replace(/-+$/g, "");

// Validates that a slug is already in kebab-case (a-z, 0-9, single dashes).
export const isValidSlug = (s: string): boolean =>
  s.length >= 3 && /^[a-z0-9]+(-[a-z0-9]+)*$/.test(s);
